import { render } from "./TrabajosRealizadosProveedorFooter.vue?vue&type=template&id=b428e9e4"
import script from "./TrabajosRealizadosProveedorFooter.vue?vue&type=script&lang=js"
export * from "./TrabajosRealizadosProveedorFooter.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__